// LangSwitcher — lets the user switch the interface language.
// Shows current language code; calls setLang via el.call.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.

const SUPPORTED_LANGS = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' }
]

export const LangSwitcherItem = {
  extends: 'Button',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z1 A',
  round: 'Z',
  cursor: 'pointer',
  theme: 'tertiary',
  width: '100%',

  Code: {
    tag: 'span',
    fontSize: 'Y2',
    fontWeight: '600',
    color: 'caption',
    width: 'B',
    text: (el, s) => (s.code || '').toUpperCase()
  },
  Label: {
    tag: 'span',
    fontSize: 'Z2',
    text: (el, s) => s.label || ''
  },

  onClick: (e, el, s) => {
    e.preventDefault()
    let dropdown = el.parent
    while (dropdown && !dropdown.LangSwitcherDropdown) dropdown = dropdown.parent
    if (dropdown?.LangSwitcherDropdown) {
      dropdown.LangSwitcherDropdown.update?.({
        style: { opacity: '0', visibility: 'hidden', pointerEvents: 'none' }
      })
    }
    el.call('setLang', s.code)
  }
}

export const LangSwitcherDropdown = {
  position: 'absolute',
  top: '100%',
  right: '0',
  zIndex: '100',
  minWidth: 'G',
  padding: 'Z',
  round: 'A',
  theme: 'dialog',
  boxShadow: '0 A Z -Z black.2',
  opacity: '0',
  visibility: 'hidden',
  pointerEvents: 'none',

  childExtends: 'LangSwitcherItem',
  childrenAs: 'state',
  children: SUPPORTED_LANGS
}

export const LangSwitcher = {
  position: 'relative',

  Trigger: {
    extends: 'Button',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',
    title: 'Change language',

    Code: {
      tag: 'span',
      fontSize: 'Y2',
      fontWeight: '600',
      text: (el, s) => (s.root?.lang || 'en').toUpperCase()
    },

    onClick: (e, el) => {
      e.stopPropagation()
      const switcher = el.parent
      const dropdown = switcher?.LangSwitcherDropdown
      if (!dropdown) return
      const next = !dropdown.forcedVisible
      dropdown.forcedVisible = next
      dropdown.update?.({
        style: {
          opacity: next ? '1' : '0',
          visibility: next ? 'visible' : 'hidden',
          pointerEvents: next ? 'auto' : 'none'
        }
      })
    }
  },

  LangSwitcherDropdown: {}
}
